import src from "IMAGE";
export default { src, width: 360, height: 60, blurWidth: 8, blurHeight: 1, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAABCAYAAADjAO9DAAAALElEQVR42gEhAN7/AG0uwv9OHJ//Mgx2/ygHZv8mB2L/LAlo/0ISgP9jIKL/71gOzWqoxbYAAAAASUVORK5CYII="};
